import React from "react";

const Searchapi = ({cat,entry}) => {
    
  return (
        <div className="d-flex justify-content-center">
            <div>
            <label htmlFor="">
                Welcome to Public API List where you can find a list of free publicly available API's <br/>
                Select category of the API you are looking for 
            </label>
            <select name="" class="form-control" id="" onChange={(e)=>{entry(e.target.value)}}>
            <option value="">Select Category</option>
                {cat.map((category=>{
                    return <option key={category} value={category}>{category}</option>
                }))}
            </select>
            </div>
            

        </div>
  );
};

export default Searchapi;
